import api from '../../utils/api'

const API_BASE_URL = "/admin/ADPParam";

const ADPParamService = {
  async findAll(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`);
    return response.data;
  },

  async getItemById(parameterId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${parameterId}`);
    return response.data;
  },

  async create(user: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, user);
    return response.data;
  },

  async update(parameterId: string, user: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${parameterId}`, user);
    return response.data;
  },

  async delete(parameterId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${parameterId}`);
    return response.data;
  },

  async getDropdown(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown`);
    return response.data;
  }
};



export default ADPParamService;